// @ts-nocheck

import axios from "axios";
import { useEffect } from "react";
import { useAppSelector } from "../hooks";

export default function DevRevSupport(props: any) {

    const authAccount = useAppSelector(state => state.authAccount.data)

    useEffect(() => {
        (async () => {
            if (authAccount && authAccount.firstName && authAccount.primaryEmail) {
                const response = await axios.get(`https://gzdhebwcxvpuibrqox7igbi4hm0qyecs.lambda-url.us-east-2.on.aws?name=${encodeURIComponent(`${authAccount.firstName} ${authAccount.lastName ? authAccount.lastName : ''}`)}&email=${authAccount.primaryEmail}`)
                if (response.data.sessionToken) {
                    console.log(response.data.sessionToken)
                    const widget = new window.DevRevSupportSdk({
                        'sessionToken': response.data.sessionToken
                    });
                }
            } else {
                const response = await axios.get(`https://gzdhebwcxvpuibrqox7igbi4hm0qyecs.lambda-url.us-east-2.on.aws`)
                if (response.data.sessionToken) {
                    console.log(response.data.sessionToken)
                    const widget = new window.DevRevSupportSdk({
                        'sessionToken': response.data.sessionToken
                    });
                }
            }
        })()
    }, [])

    return (
        <div>

        </div>
    )
}